import { render, staticRenderFns } from "./college.html?vue&type=template&id=bb413348&scoped=true&external"
import script from "./college.js?vue&type=script&lang=js&external"
export * from "./college.js?vue&type=script&lang=js&external"
import style0 from "./college.scss?vue&type=style&index=0&id=bb413348&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb413348",
  null
  
)

export default component.exports